import firebase from './firebase'
import StageDescription from '../model/StageDescription'
import { Object2StageDescription } from '@/ts/model/archivers'
import AuthApi from './AuthApi'
import DocListItem from '@/ts/if/DocListItem'

const db = firebase.firestore()

const getUid = async () => {
  const user = await AuthApi.getUser()
  if (!user) { return null }
  return user.uid
}

const createNewDoc = async () => {
  const ref = db.collection('userDocs').doc()
  const id = ref.id
  const uid = await getUid()
  if (!uid) { return undefined }
  await ref.set({
    id,
    uid,
    created: new Date(),
    updated: new Date(),
    stage: null
  })
  return id
}

const listDocs = async () => {
  const list: DocListItem[] = []
  const uid = await getUid()
  if (!uid) { return list }
  const ref = db.collection('userDocs').where('uid', '==', uid).limit(100)
  const docs = await ref.get()
  docs.forEach(doc => {
    const data = doc.data()
    if (data) {
      if (data.stage) {
        list.push({
          id: data.id,
          thumbData: (data && data.stage) ? data.stage.thumbData : null,
          isOrdered: !!data.isOrdered
        })
      }
    }
  })
  return list
}

const readDoc = async (id: string) => {
  const ref = db.collection('userDocs').doc(id)
  const doc = await ref.get()
  if (!doc.exists) { return undefined }
  const data = doc.data()
  if (data) {
    const stageData = data.stage
    const stage = Object2StageDescription(stageData)
    return {
      stage,
      isOrdered: !!data.isOrdered
    }
  }
}

const saveDoc = async (id: string, stage: StageDescription) => {
  const ref = db.collection('userDocs').doc(id)
  const doc = await ref.get()
  if (!doc.exists) { return false }
  const stageDataObj = JSON.parse(JSON.stringify(stage))
  await ref.update({
    stage: stageDataObj,
    updated: new Date()
  })
  return true
}

const changeOrderFlag = async (id: string, flag: boolean, itemType?: string) => {
  const user = await AuthApi.getUser()
  if (!user || user.isAnonymous) {
    console.warn('not loggedin')
    return false
  }
  if (!id) {
    console.warn('no doc id')
    return false
  }
  if (flag && !itemType) {
    return false
  }
  const ref = db.collection('userDocs').doc(id)
  const doc = await ref.get()
  if (!doc.exists) {
    console.warn('no doc exists')
    return false
  }
  try {
    console.log('update order:', AuthApi.twUid, AuthApi.twName)
    await ref.update({
      isOrdered: flag,
      [flag ? 'ordered' : 'canceled']: new Date(),
      itemType: itemType || null,
      updated: new Date(),
      twitterUid: AuthApi.twUid,
      twitterName: AuthApi.twName
    })
  } catch (ex) {
    console.warn('failed to update', ex)
    return false
  }
  return true
}

const orderDoc = async (id: string, itemType: string) => {
  return changeOrderFlag(id, true, itemType)
}

const cancelOrderDoc = async (id: string) => {
  return changeOrderFlag(id, false)
}

const deleteDoc = async (id: string) => {
  const ref = db.collection('userDocs').doc(id)
  const doc = await ref.get()
  if (!doc.exists) { return false }
  try {
    await ref.delete()
    return true
  } catch {
    return false
  }
}

const DocApi = {
  createNewDoc,
  readDoc,
  listDocs,
  saveDoc,
  orderDoc,
  cancelOrderDoc,
  deleteDoc
}

export default DocApi
